import { useState, useEffect } from "react";
import { getAttendenceStatus } from "api/attendance";
import { processTimelineData } from "../utils/timelineUtils";

// export const useAttendanceData = () => {
//   const [statusData, setStatusData] = useState(null);
//   const [timelineData, setTimelineData] = useState([]);
//   const [processedTimelineData, setProcessedTimelineData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [refreshing, setRefreshing] = useState(false);

//   const fetchStatusAndTimelineData = async () => {
//     try {
//       setLoading(true);
//       const response = await getAttendenceStatus();
//       if (response && response) {
//         setStatusData(response);
//         setTimelineData(response.timeline || []);
//         const processed = processTimelineData(response.timeline || []);
//         setProcessedTimelineData(processed);
//       }
//     } catch (error) {
//       console.error('Error fetching attendance status:', error);
//     } finally {
//       setLoading(false);
//       setRefreshing(false);
//     }
//   };

//   useEffect(() => {
//     fetchStatusAndTimelineData();
//   }, []);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (statusData?.logical_date === new Date().toISOString().split("T")[0]) {
//         fetchStatusAndTimelineData();
//       }
//     }, 60000);

//     return () => clearInterval(interval);
//   }, [statusData]);

//   const handleRefresh = () => {
//     setRefreshing(true);
//     fetchStatusAndTimelineData();
//   };

//   return {
//     statusData,
//     timelineData,
//     processedTimelineData,
//     loading,
//     refreshing,
//     handleRefresh,
//     fetchStatusAndTimelineData
//   };
// };

export const useAttendanceData = () => {
  const [statusData, setStatusData] = useState(null);
  const [timelineData, setTimelineData] = useState([]);
  const [processedTimelineData, setProcessedTimelineData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const fetchStatusAndTimelineData = async (params = {}) => {
    try {
      setLoading(true);
      const response = await getAttendenceStatus(params);

      if (response) {
        setStatusData(response);

        const timeline = response.timeline.map((record) => ({
          date: record.date,

          // STATUS & TYPE
          status: record.status || "absent",
          status_reason: record.status_reason || null,
          type: record.type || "working_day",
          attendance_status: record.attendance_status || null,

          // TIME
          in: record.in || null,
          out: record.out || null,
          shift_start: record.shift_start || "09:00",
          shift_end: record.shift_end || "18:00",

          // METRICS
          worked_minutes: record.worked_minutes || 0,
          attendance_break_minutes: record.attendance_break_minutes || 0,

          // BREAKS
          breaks: Array.isArray(record.breaks) ? record.breaks : [],

          // RAW (future proof)
          raw: record,
        }));

        setTimelineData(response.timeline || []);
        setProcessedTimelineData(timeline);
      }
    } catch (error) {
      console.error("Error fetching attendance status:", error);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    fetchStatusAndTimelineData();
  }, []);

  const handleRefresh = () => {
    setRefreshing(true);
    fetchStatusAndTimelineData();
  };

  return {
    statusData,
    timelineData,
    processedTimelineData,
    loading,
    refreshing,
    handleRefresh,
    fetchStatusAndTimelineData, // 👈 IMPORTANT
  };
};
